import React from 'react';
import HeroSection from '../components/HeroSection';
import StorySection from '../components/StorySection';
import ProductsSection from '../components/ProductsSection';
import SpecialtiesSection from '../components/SpecialtiesSection';
import EventsSection from '../components/EventsSection';
import GallerySection from '../components/GallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <HeroSection />
      <StorySection />
      <ProductsSection />
      <SpecialtiesSection />
      <EventsSection />
      <GallerySection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
